import { Skeleton } from "src/atoms/Skeleton";
import { theme } from "src/theme";
import { PromotionBlockSkeletonWrapper } from "./ProductList.styled";

function PromotionBlockSkeleton(): JSX.Element {
  return (
    <PromotionBlockSkeletonWrapper>
      <Skeleton height={theme.space.space64} />
    </PromotionBlockSkeletonWrapper>
  );
}

export { PromotionBlockSkeleton };
